export const DEFAULT_IMAGE_SCALE_FACTOR = 1;
